import { createFileRoute } from "@tanstack/react-router";

import QuestEntries from "@/components/QuestEntries/QuestEntries";

const Component = () => {
  const { questUuid } = Route.useParams();
  return <QuestEntries questUuid={questUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/entries")({
  component: Component,
});
